import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PWordmark } from '@porsche-design-system/components-react';

const WordmarkContainer = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'end',
    gap: 'md',
    paddingTop: 'lg',
    paddingBottom: 'lg',

    '&:before': {
      content: '""',
      display: 'block',
    },
    '&:after': {
      content: '""',
      display: 'block',
    },
  },
});

export const Header = () => {
  return (
    <WordmarkContainer>
      <PWordmark />
    </WordmarkContainer>
  );
};
